import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    alreadyRenderingTitle: string;
    noOutputTitle: string;
    noProjectTitle: string;
    nothingToRenderTitle: string;
    unknownErrorTitle: string;
    unsupportedRenderOutputTitle: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast title shown when an AE render fails because another render is already in progress */
            alreadyRenderingTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenderJobEvents.alreadyRenderingTitle?c=1b46wsbtf4c9b", defaultMessage: "Another render is already in progress" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when an AE render finishes without producing any output files (e.g., stopped midway) */
            noOutputTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenderJobEvents.noOutputTitle?c=1tmvykte1gmki", defaultMessage: "Render stopped before producing any files" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when an AE render fails because no After Effects project is open */
            noProjectTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenderJobEvents.noProjectTitle?c=1sy4m951wri2a", defaultMessage: "No After Effects project open" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when an AE render fails because the render queue is empty */
            nothingToRenderTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenderJobEvents.nothingToRenderTitle?c=1tdjyaxwenei1", defaultMessage: "Nothing to render" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Generic toast title shown when an AE render fails for an unknown reason */
            unknownErrorTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenderJobEvents.unknownErrorTitle?c=3pqrtqpjlmwub", defaultMessage: "Render failed" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast title shown when an AE render fails because the render output module is unsupported*/
            unsupportedRenderOutputTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenderJobEvents.unsupportedRenderOutputTitle?c=3efmt3nd85ddh", defaultMessage: "Unsupported render output" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
